<template>
  <div class="customcommunity-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Select
              v-model="formItem.review_status"
              clearable
              style="width:80px"
              placeholder="请选择状态..."
            >
              <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select v-model="formItem.custom_made_cate_id" clearable filterable placeholder="选择分类">
              <Option
                v-for="item in custommadecateList"
                :value="item.id"
                :key="item.id"
              >{{item.title}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入定制名称查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>

    <Drawer :title="title" v-model="showModalStatus" width="600" :mask-closable="false" :styles="styles">
      <Form :model="dataInfo" label-position="left" :label-width="100">
        <FormItem label="分类">
          <span v-if="dataInfo.cate !='' ">{{ dataInfo.cate.title }}</span>
        </FormItem>
        <FormItem label="名称" prop="title">
          <span>{{ dataInfo.title }}</span>
        </FormItem>
        <FormItem label="价格">
          <span>{{ dataInfo.price }}</span>
        </FormItem>
        <FormItem label="图集" prop="album">
          <div class="upload-list" v-for="item in dataInfo.attrShow" :key="item">
            <img :src="item" />
          </div>
        </FormItem>
        <FormItem label="内容" prop="content">
          <span v-html="dataInfo.content"></span>
        </FormItem>
        <FormItem label="合作商家">
          <span v-html="dataInfo.tradesman_nickname"></span>
        </FormItem>
        <FormItem label="状态">
          <span v-if="dataInfo.review_status ==1">通过</span>
          <span v-else-if="dataInfo.review_status ==-1">驳回</span>
          <span v-else>待审核</span>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
      </div>
    </Drawer>

    <Modal v-model="showPriceModalStatus" :title="title" @on-ok="editPrice('priceInfoValidate')" :loading="loading">
      <Form :model="priceInfo" ref="priceInfoValidate" :rules="priceInfoValidate" action="javascript:void(0)">
        <FormItem label="审核状态" prop="review_status">
          <Select v-model="priceInfo.review_status" clearable style="width:80px" placeholder="请选择状态...">
            <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";

export default {
  name: "customcommunity-list",
  data() {
    const validateStatus = (rule, value, callback) => {
      if (this.dataInfo.custom_made_cate_id === "") {
        callback(new Error("请选择审核状态"));
      } else {
        callback();
      }
    };
    return {
      statusList: [
        { id: 1, name: "通过" },
        { id: 0, name: "待审核" },
        { id: -1, name: "不通过" }
      ],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      loading: true,
      dataloading: true,
      // 编辑器用的
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: "",
        custom_made_cate_id: "",
        review_status: ""
      },
      isable: true,
      showPriceModalStatus: false,
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "名称",
          key: "title",
          width: 300
        },
        {
          title: "分类",
          key: "cate",
          width: 100
        },
        {
          title: "用户",
          key: "username",
          width: 150
        },
        {
          title: "价格",
          key: "price",
          width: 100
        },
          {
              title: "定制状态",
              key: "status",
              width: 100,
              render: (h, params) => {
                  var par = params.row.work_status == 0 ? "招标中" : "已招标";
                  return h("tag", {
                          props: {
                              color: params.row.work_status == "0" ? "geekblue" : "red"
                          }
                      },
                      par
                  );
              }
          },
        {
          title: "审核状态",
          key: "display",
          width: 100,
          render: (h, params) => {
            var par =
              params.row.review_status == 1
                ? "通过"
                : params.row.review_status == -1
                ? "未通过"
                : "待审核";
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.review_status == "1"
                      ? "geekblue"
                      : params.row.review_status == -1
                      ? "red"
                      : "orange"
                }
              },
              par
            );
          }
        },
        {
          title: "发布时间",
          key: "created_at",
          width: 180
        },
        {
          title: "操作",
          key: "action",
          width: 140,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    // display: params.row.review_status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.detailPrice(params.row.id);
                    }
                  }
                },
                "审核"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      custommadecateList: [],
      showModalStatus: false,
      dataInfo: {
        cate: {}
      },
      priceInfo: {
        review_status: 0
      },
      priceInfoValidate: {
        review_status: [
          { required: true, validator: validateStatus, trigger: "change" }
        ]
      }
    };
  },
  created: function() {
    this.$api.custommadecate.list({ size: 9999 }).then(res => {
      if (res.code == 200) {
        this.custommadecateList = res.result.list;
      }
    });
    // 取数据
    this.getTableList();
  },
  components: {
    // EditorBar,
    UploadThumb
  },
  methods: {
    getTableList: function() {
      this.$api.customcommunity
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    //审核
    detailPrice(id) {
      this.title = "审核";
      this.priceInfo.id = id;
      this.showPriceModalStatus = !this.showPriceModalStatus;
    },
    // 详情
    detail(id) {
      this.title = "详情";
      this.showModalStatus = !this.showModalStatus;
      this.$api.customcommunity.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
      });
    },
    //审核
    editPrice(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.customcommunity.review(this.priceInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showPriceModalStatus = !this.showPriceModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.customcommunity.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        review_status: this.formItem.review_status,
        custom_made_cate_id: this.formItem.custom_made_cate_id,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.customcommunity.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
